<script>
import BackgroundVideo from '@maison/components/molecules/BackgroundVideo';
import PictureLazy from '@maison/components/common/PictureLazy.vue';

export default {
  components: {
    BackgroundVideo,
    PictureLazy,
  },
  inject: ['reversoFilterId'],

  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
  },

  methods: {
    filterToMonoOrReverso(value) {
      this.$emit('onToggleFilter', this.reversoFilterId, [value]);
    },
  },
};
</script>

<template>
  <div class="mixed-grid-push-filters">
    <h4 v-if="title" class="h5 mb-sm">{{ title }}</h4>

    <div class="mixed-grid-push-filters__items">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="mixed-grid-push-filters__col"
        :data-cy="`mixed-grid-reverso-filter-item-${index}`"
      >
        <div class="mixed-grid-push-filters__media">
          <background-video v-if="item.video" :video-id="`reversoFilter-video-${index}`" v-bind="item.video" />
          <div v-else-if="item.image" class="picture picture--cover">
            <picture-lazy v-bind="item.image" />
          </div>
        </div>

        <div class="mixed-grid-push-filters__wrapper">
          <div class="mixed-grid-push-filters__container">
            <h5 class="mixed-grid-push-filters__title h4">{{ item.title }}</h5>

            <div class="mixed-grid-push-filters__text">{{ item.description }}</div>
            <button
              class="expand-target"
              :aria-label="$t(index === 0 ? 'ReversoFilter.filterByMonoface' : 'ReversoFilter.filterByDuoface')"
              @click="() => filterToMonoOrReverso(item.value)"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
